import { Box, Typography, Grid, List, ListItem } from "@mui/material";
import { Link as ReactLink } from "react-router-dom";

const SitemapContainer = () => {
  const headerStyle = {
    fontWeight: 600,
    textDecoration: "none",
    color: "black",
    fontSize: "20px",
  };
  const textStyle = {
    fontWeight: 400,
    textDecoration: "none",
    color: "black",
  };
  return (
    <>
      <Box
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: "2em",
        }}
      >
        <Box
          style={{
            width: "100%",
            background:
              "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
          }}
        >
          <Typography
            style={{
              padding: "32px",
              width: "100%",
              justifyContent: "flex-end",
              display: "flex",
              boxSizing: "border-box",
              marginRight: "32px",
            }}
            fontSize="32px"
            fontWeight={600}
          >
            SITEMAP
          </Typography>
        </Box>
        <Box
          style={{
            maxWidth: "960px",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography
                fontWeight={600}
                fontSize="26px"
                margin="16px 0px 6px"
              >
                Sitemap
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <ReactLink
                to={{ pathname: "/about" }}
                style={{ textDecoration: "none" }}
              >
                <Typography style={headerStyle}>About</Typography>
              </ReactLink>
              <List>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/about/members" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Research Group Members
                    </Typography>
                  </ReactLink>
                </ListItem>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/about/awards" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Awards and Fellowships
                    </Typography>
                  </ReactLink>
                </ListItem>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/about/talks" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>Invited Talks</Typography>
                  </ReactLink>
                </ListItem>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/about/teaching" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>Teaching</Typography>
                  </ReactLink>
                </ListItem>
              </List>
              <ReactLink
                to={{ pathname: "/News" }}
                style={{ textDecoration: "none" }}
              >
                <Typography style={headerStyle}>News</Typography>
              </ReactLink>
            </Grid>
            <Grid item xs={6}>
              <ReactLink
                to={{ pathname: "/publications" }}
                style={{ textDecoration: "none" }}
              >
                <Typography style={headerStyle}>Publications</Typography>
              </ReactLink>
              <List>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/publications/books" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>Published Books</Typography>
                  </ReactLink>
                </ListItem>
              </List>
              <ReactLink
                to={{ pathname: "/projects" }}
                style={{ textDecoration: "none" }}
              >
                <Typography style={headerStyle}>Projects</Typography>
              </ReactLink>
              <List>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/projects/energy-insecurity" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Energy Inecurity in Hong Kong
                    </Typography>
                  </ReactLink>
                </ListItem>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/projects/intangiable-assets" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Intangiable Assets in Rice Farming
                    </Typography>
                  </ReactLink>
                </ListItem>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/projects/investigating-energy" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Investigating Japan Energy
                    </Typography>
                  </ReactLink>
                </ListItem>
                <ListItem>
                  <ReactLink
                    to={{ pathname: "/projects/climate-fragility" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Climate Fragility in Philippine
                    </Typography>
                  </ReactLink>
                </ListItem>

                <ListItem>
                  <ReactLink
                    to={{ pathname: "/projects/hongkong-energy" }}
                    style={{ textDecoration: "none" }}
                  >
                    <Typography style={textStyle}>
                      Hong Kong’s Energy Transition
                    </Typography>
                  </ReactLink>
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default SitemapContainer;
